import type { QueryValue } from '~~/types/extraGuarantee/LocationQueryValueRecord';
import type { ShareBasketItem, ParsedShareBasketParams } from '~~/types/checkout/ShareBasketItem';
import { EXPONDO_EMAIL_DOMAIN_PATTERN } from '~~/constants/regex';

const normalizeExtraGuaranteeSku = (value: unknown): string | false => {

  if (typeof value === 'string' && value.trim() !== '') {

    return value;

  }

  return false;

};

const isValidShareBasketItem = (item: unknown): item is ShareBasketItem => {

  if (!item || typeof item !== 'object') {

    return false;

  }

  const candidate = item as Record<string, unknown>;

  return typeof candidate.sku === 'string' && candidate.sku.trim() !== '' &&
    typeof candidate.quantity === 'number' && Number.isInteger(candidate.quantity) && candidate.quantity > 0 &&
    (
      typeof candidate.extraGuaranteeSku === 'string'
      || typeof candidate.extraGuaranteeSku === 'boolean'
    );

};

export const isExpondoEmail = (email: string): boolean =>
  EXPONDO_EMAIL_DOMAIN_PATTERN.test(email);

const parseItems = (items: unknown[]): ShareBasketItem[] =>
  items
    .filter(isValidShareBasketItem)
    .map(item => ({
      ...item,
      extraGuaranteeSku: normalizeExtraGuaranteeSku(item.extraGuaranteeSku),
    }));

export const parseShareBasketParams = (rawParams: QueryValue | QueryValue[]): ParsedShareBasketParams => {

  try {

    const paramsString = Array.isArray(rawParams) ? rawParams[0] : rawParams;

    if (!paramsString) {

      return { items: [] };

    }

    const decodedString = decodeShareBasketBase64(paramsString.toString());
    const parsed = JSON.parse(decodedString);

    // Legacy array for links generated before introducing orderReferrer
    if (Array.isArray(parsed)) {

      return { items: parseItems(parsed) };

    }

    if (parsed && typeof parsed === 'object' && Array.isArray(parsed.products)) {

      const orderReferrer = typeof parsed.orderReferrer === 'string' && isExpondoEmail(parsed.orderReferrer)
        ? parsed.orderReferrer
        : undefined;

      return {
        items: parseItems(parsed.products),
        orderReferrer,
      };

    }

    return { items: [] };

  } catch {

    return { items: [] };

  }

};

const decodeShareBasketBase64 = (str: string): string => {

  const decodedString = typeof window !== 'undefined'
    ? atob(str)
    : Buffer.from(str, 'base64').toString('utf-8');

  try {

    return decodeURIComponent(decodedString);

  } catch {

    return decodedString;

  }

};
